<template>
  <div id="consultarUGsWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres
          titulo="Unidades Gestoras (UGs)"
          breakpoint="md"
          :botoes="botoesHeader"
        />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form
            @submit.stop.prevent="filtrarUGs"
            @reset.prevent="limparFiltros"
          >
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Nome"
                  label-for="input-nome"
                  label-class="text-left"
                >
                  <b-form-input
                    id="input-nome"
                    v-model="filtroNome"
                    placeholder="Nome da UG"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Município"
                  label-for="select-municipio"
                  label-class="text-left"
                >
                  <b-overlay :show="loadingMunicipio">
                    <b-form-select
                      id="select-municipio"
                      :options="listaMunicipios"
                      v-model="filtroMunicipio"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pt-4">
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="mr-2"
                  type="reset"
                >
                  <font-awesome-icon icon="redo" class="mr-2" />
                  Limpar Filtros
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  type="submit"
                  :disabled="loadingMunicipio"
                >
                  <font-awesome-icon icon="filter" class="mr-2" />
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>
        <b-table
          :busy="isBusy"
          :fields="fields"
          hover
          no-border-collapse
          :items="items"
          :sort-desc="true"
          striped
          small
          per-page="0"
          :current-page="currentPage"
          stacked="lg"
          show-empty
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-md-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="verDetalhes(row.item.Id)">
                <font-awesome-icon icon="eye" />
                <span>Ver Detalhes</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editarUg(row.item.Id)">
                <font-awesome-icon icon="pencil" />
                <span>Editar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="row.item.IdStatus === 1"
                @click="aprovarAcao(row.item, 'inativar')"
              >
                <font-awesome-icon icon="xmark" />
                <span>Inativar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-else
                @click="aprovarAcao(row.item, 'reativar')"
              >
                <font-awesome-icon icon="check" />
                <span>Reativar</span>
              </b-dropdown-item>
            </b-dropdown>
            <div
              class="actions-icons lgvert d-none d-md-flex justify-content-center"
            >
              <b-link class="text-dark" @click="verDetalhes(row.item.Id)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Ver Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarUg(row.item.Id)">
                <font-awesome-icon icon="pencil" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link
                v-if="row.item.IdStatus === 1"
                class="text-dark"
                @click="aprovarAcao(row.item, 'inativar')"
              >
                <font-awesome-icon icon="xmark" />
                <div style="font-size: 12px">Inativar</div>
              </b-link>
              <b-link
                v-else
                class="text-dark"
                @click="aprovarAcao(row.item, 'reativar')"
              >
                <font-awesome-icon icon="check" />
                <div style="font-size: 12px">Reativar</div>
              </b-link>
            </div>
          </template>
        </b-table>
        <table-pagination
          v-if="totalRows"
          :total-rows="totalRows"
          :per-page="perPage"
          @pageChange="pageChange"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { fieldsUGs } from "@/types/administracao/ug/fields-ugs";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { SelectValue } from "@/types/select-value";
import { PortalError } from "@/types/portal-error";
import ugService from "@/services/administracao/ugService";
import { UgResumido } from "@/types/administracao/ug/ug-resumido";
import municipioService from "@/services/administracao/municipioService";
import { Municipio } from "@/types/administracao/municipio";
import { BotaoSagres } from "@/types/botao-sagres";

const CompProps = Vue.extend({
  name: "ConsultarUnidadesGestoras",
  components: {
    CardFiltrosBusca,
    HeaderSagres,
    TablePagination,
  },
});

@Component
export default class ConsultarUnidadesGestoras extends mixins(
  UtilsTS,
  CompProps
) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "plus",
      texto: "Criar UG",
      acao: () => this.$router.push("/administracao/criar-unidade-gestora"),
    },
  ];
  fields: TableField[] = fieldsUGs;
  isBusy = true;
  loadingMunicipio = true;

  titulo = "";
  perPage = 10;
  currentPage = 1;
  totalRows = 0;

  items: UgResumido[] = [];
  listaMunicipios: SelectValue[] = [];

  filtroMunicipio: number | null = null;
  filtroNome: string | null = null;

  async pageChange(value: number): Promise<void> {
    try {
      this.isBusy = true;
      this.currentPage = value;
      const response = await ugService.getAllUnidadeGestora(
        this.currentPage,
        this.filtroNome,
        this.filtroMunicipio
      );
      this.items = response.ugs;
      this.totalRows = response.totalRows;
    } catch (error: unknown) {
      this.tratarError(error);
      this.items = [];
    } finally {
      this.isBusy = false;
    }
  }

  async filtrarUGs(): Promise<void> {
    await this.pageChange(1);
  }

  limparFiltros(): void {
    this.filtroNome = null;
    this.filtroMunicipio = null;
  }

  async getListaMunicipios(): Promise<void> {
    try {
      this.loadingMunicipio = true;
      const response = await municipioService.getMunicipios(29);
      this.listaMunicipios = response.map((a: Municipio) => {
        return { text: this.capitalize(a.NM_NOME), value: a.ID_MUNICIPIO };
      });
      this.listaMunicipios.unshift({
        value: null,
        text: "Selecione o município",
      });
      this.filtroMunicipio = null;
    } catch (error: unknown) {
      this.tratarError(error);
      this.listaMunicipios = [];
    } finally {
      this.loadingMunicipio = false;
    }
  }

  async editarUg(id: number): Promise<void> {
    try {
      await this.$router.push(`/administracao/editar-unidade-gestora/${id}`);
    } catch (error: unknown) {
      this.$toast.error("Erro ao redirecionar tela");
      throw new PortalError(`Erro ao redirecionar tela: ${error}`);
    }
  }

  aprovarAcao(ug: UgResumido, comando: "inativar" | "reativar") {
    this.$bvModal
      .msgBoxConfirm(`Deseja ${comando} a UG ${ug.UgNmNome}?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        okVariant: "secondary",
        title: `${this.capitalize(comando)} UG`,
      })
      .then(async (value) => {
        if (value)
          if (comando === "inativar") await this.inativarUg(ug);
          else await this.reativarUg(ug);
      })
      .catch((err) => {
        console.error(`Erro ao operar o diálogo de alerta`, err);
      });
  }

  async inativarUg(ug: UgResumido) {
    try {
      this.isBusy = true;
      const response = await ugService.inativarUg(ug.Id);
      response
        ? this.$toast.success(
            `Inativação de ${ug.UgNmNome} concluída com sucesso!`
          )
        : this.$toast.error("Erro ao concluir inativação");
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.filtrarUGs();
      this.isBusy = false;
    }
  }

  async reativarUg(ug: UgResumido) {
    try {
      this.isBusy = true;
      const response = await ugService.reativarUg(ug.Id);
      if (response)
        this.$toast.success(
          `Reativação de ${ug.UgNmNome} concluída com sucesso!`
        );
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      await this.filtrarUGs();
      this.isBusy = false;
    }
  }

  async verDetalhes(idUg: number) {
    await this.$router.push(
      `/administracao/ver-unidade-gestora/${idUg}/${true}`
    );
  }

  mounted(): void {
    this.getListaMunicipios();
    this.filtrarUGs();
  }
}
</script>
